import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, requireRole, requireUserType }) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role") || "";
  const userType = localStorage.getItem("userType") || "";

  if (!token) {
    // not logged in
    if (requireUserType === "platform") {
      return <Navigate to="/super_admin/login" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  // role check
  if (requireRole && role !== requireRole) {
    if (requireUserType === "platform") {
      return <Navigate to="/super_admin/login" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  // userType check
  if (requireUserType && userType !== requireUserType) {
    if (requireUserType === "platform") {
      return <Navigate to="/super_admin/login" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
}
